import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileBottomNav, MobileHamburgerMenu } from './MobileNav';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
import { LinkLogo } from '@/components/ui/LinkLogo';


interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex w-full bg-background">
      {/* Desktop/Tablet Sidebar - Hidden on mobile */}
      <div className="hidden md:block">
        <Sidebar />
      </div>
      
      <div className="flex-1 flex flex-col min-w-0">
        {/* Mobile Header - Icon-only logo */}
        <header className="flex md:hidden items-center justify-between h-14 px-4 border-b border-border bg-sidebar/95 backdrop-blur-xl sticky top-0 z-40">
          <button 
            onClick={handleLogoClick}
            className="flex items-center gap-2 group cursor-pointer transition-all duration-200 hover:opacity-80 min-h-[44px]"
          >
            <LinkLogo showText={false} size="sm" />
          </button>
          <div className="flex items-center gap-1">
            <MobileHamburgerMenu />
          </div>
        </header>

        {/* Desktop/Tablet TopBar */}
        <div className="hidden md:block">
          <TopBar />
        </div>
        
        <main className={`flex-1 overflow-auto scrollbar-thin ${isMobile ? 'pb-24' : ''}`}>
          <div className="page-shell-main-compact">{children}</div>
        </main>
      </div>
      
      {/* Mobile Bottom Navigation */}
      <MobileBottomNav className="md:hidden" />
    </div>
  );
}
